import { useCallback, useRef } from 'react'

import { pruneNilValues } from '@core/object'
import {
  appContextToTrackingDataPixel,
  sendPixelTrackingWithSession,
} from '@core/tracking/senders'
import { useStoreApi } from '@core/widgets/store'
import { FEED_CONTROL_GROUP_EMBED_INSTANCE } from '@core/widgets/tracking/endpoints'
import type { AnyWidgetAppContext } from '@embed/hooks/useEmbedAppContext'

/**
 * create callback to send tracking data for users who are in an AB test that hides the widgets
 */
export const useTrackControlGroupEmbedInstance = () => {
  const storeApi = useStoreApi()
  const tracked = useRef(false)

  return useCallback(
    (appContext: AnyWidgetAppContext) => {
      if (!appContext || tracked.current) {
        return
      }
      tracked.current = true
      const { params } = storeApi.getState()
      const pixelTrackingData = appContextToTrackingDataPixel({ appContext })
      const data = {
        event_properties: pruneNilValues(pixelTrackingData),
      }

      sendPixelTrackingWithSession({
        endpoint: FEED_CONTROL_GROUP_EMBED_INSTANCE,
        data,
        host: params.api_host_tracking,
      })
    },
    [storeApi],
  )
}
